import GatewayRetailerLookupAutocomplete from "./GatewayRetailerLookupAutocomplete";

const MissingRetailerControl = ({
  retailerName,
  onRetailerNameChange,
  retailerId,
  onRetailerIdChange,
}) => (
  <GatewayRetailerLookupAutocomplete
    retailerId={retailerId}
    inputSeedLabel={retailerName}
    onSelect={(option) => {
      onRetailerIdChange(option?.id || "");
      onRetailerNameChange(option?.name || option?.label || retailerName);
    }}
    onClear={() => onRetailerIdChange("")}
    label="Lookup retailer"
    helperText="Search and select an existing Gateway retailer."
    wrapInBox
  />
);

export default MissingRetailerControl;
